// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loader-container {
  background: #ffffff66;
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 10;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #9e9e9e;
}
`, "",{"version":3,"sources":["webpack://./src/components/loader/loader.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;EACX,MAAM;EACN,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB","sourcesContent":[".loader-container {\n  background: #ffffff66;\n  width: 100%;\n  height: 100vh;\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #9e9e9e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
